module.exports = __webpack_public_path__ + "img/daichao1.76e820fe.png";